export type MovieType = '电视剧' | '电影';

export interface Movie {
  id: string;
  title: string;
  type: MovieType;
  year: number;
  region: string;
  duration: string;
  episodes?: number;
  actors: string[];
  director: string;
  genres: string[];
  rating: number;
  heat: number;
  description: string;
  poster: string;
  backdrop?: string;
}

export const movies: Movie[] = [
  {
    id: '1',
    title: '星河彼岸',
    type: '电影',
    year: 2025,
    region: '中国大陆',
    duration: '138分钟',
    actors: ['陆沉', '苏晚', '顾清和'],
    director: '陈砚舟',
    genres: ['科幻', '冒险'],
    rating: 8.7,
    heat: 986000,
    description:
      '一支深空探索队在木星轨道发现了一处神秘的引力异常，队长林澈带领队员穿越虫洞，在星河彼岸遇见了另一个选择留下的自己。影片以冷静克制的科幻叙事，探讨人类面对未知时的勇气与孤独。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20lone%20astronaut%20drifting%20toward%20a%20glowing%20distant%20galaxy%20deep%20blue%20and%20orange%20palette%20dramatic%20rim%20lighting%20simple%20dark%20starfield%20background%20high%20detail%20moody%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr01&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20astronaut%20silhouette%20before%20a%20giant%20glowing%20planet%20deep%20blue%20space%20with%20warm%20orange%20nebula%20accents%20dramatic%20lighting%20vast%20atmospheric%20sci%20fi%20scene%20with%20soft%20film%20grain&width=1600&height=900&seq=mv-yr01b&orientation=landscape',
  },
  {
    id: '2',
    title: '长风渡',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    duration: '每集45分钟',
    episodes: 40,
    actors: ['沈砚', '柳明溪', '裴无咎'],
    director: '周听澜',
    genres: ['剧情', '历史', '古装'],
    rating: 8.9,
    heat: 1520000,
    description:
      '南北朝乱世之中，寒门少年裴无咎凭一身武艺投身军旅，从边关小卒一路成长为护国将军。他与将门之女柳明溪在烽火里相知相守，共同守护一座风雨飘摇的城池。历史厚重感与人物成长线交织，铺陈出一幅动荡年代的家国画卷。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20poster%20of%20a%20young%20warrior%20in%20traditional%20chinese%20armor%20standing%20on%20a%20misty%20city%20wall%20deep%20blue%20dusk%20sky%20with%20orange%20torchlight%20dramatic%20epic%20composition%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr02&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20ancient%20chinese%20city%20wall%20at%20dusk%20with%20torch%20lights%20and%20mist%20deep%20blue%20and%20warm%20orange%20tones%20epic%20historical%20drama%20atmosphere%20high%20detail%20film%20still&width=1600&height=900&seq=mv-yr02b&orientation=landscape',
  },
  {
    id: '3',
    title: '暗夜追踪',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '每集42分钟',
    episodes: 32,
    actors: ['方远', '林夏', '周牧'],
    director: '韩牧之',
    genres: ['悬疑', '犯罪', '剧情'],
    rating: 8.5,
    heat: 1240000,
    description:
      '连续七年悬而未决的连环失踪案再度出现新线索，刑警方远与犯罪心理学顾问林夏联手追查。随着真相层层剥开，一段被刻意掩埋的往事浮出水面，真凶竟藏在他们最信任的人之中。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20poster%20of%20a%20detective%20silhouette%20in%20a%20rainy%20neon%20alley%20deep%20blue%20night%20with%20orange%20street%20glow%20tense%20moody%20atmosphere%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr03&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rainy%20city%20street%20at%20night%20with%20wet%20reflections%20and%20warm%20orange%20lamps%20against%20deep%20blue%20darkness%20tense%20crime%20thriller%20atmosphere%20high%20detail%20film%20still&width=1600&height=900&seq=mv-yr03b&orientation=landscape',
  },
  {
    id: '4',
    title: '长安旧梦',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    duration: '每集45分钟',
    episodes: 36,
    actors: ['谢知微', '云挽', '萧景行'],
    director: '顾长歌',
    genres: ['古装', '爱情', '剧情'],
    rating: 8.3,
    heat: 1120000,
    description:
      '长安城中，画师之女云挽因一幅失传的屏风画卷入宫廷纷争。她与冷面少卿萧景行从相互试探到并肩而立，在权谋暗涌与盛世繁华之间，守住心中那一点不灭的旧梦。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20chinese%20costume%20drama%20poster%20of%20an%20elegant%20woman%20in%20flowing%20hanfu%20holding%20a%20painted%20fan%20glowing%20lanterns%20deep%20blue%20night%20with%20warm%20orange%20accents%20dreamy%20romantic%20composition%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr04&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20ancient%20chinese%20palace%20at%20night%20filled%20with%20glowing%20lanterns%20deep%20blue%20sky%20and%20warm%20orange%20light%20romantic%20historical%20drama%20atmosphere%20high%20detail%20film%20still&width=1600&height=900&seq=mv-yr04b&orientation=landscape',
  },
  {
    id: '5',
    title: '城市之光',
    type: '电影',
    year: 2025,
    region: '中国大陆',
    duration: '124分钟',
    actors: ['江屿', '温言', '许南风'],
    director: '林既明',
    genres: ['剧情', '都市'],
    rating: 8.1,
    heat: 870000,
    description:
      '深夜代驾司机江屿每天穿梭在城市最真实的角落，遇见形形色色的人。一次偶然的善意，让几个陌生人的命运在城市的光影里悄然交汇。影片用温柔克制的镜头，讲述平凡人身上不平凡的光。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20a%20lone%20figure%20walking%20through%20a%20modern%20city%20at%20night%20surrounded%20by%20deep%20blue%20buildings%20and%20warm%20orange%20window%20lights%20reflective%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr05&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20cityscape%20at%20night%20with%20glowing%20windows%20and%20reflective%20wet%20streets%20deep%20blue%20tones%20with%20warm%20orange%20lights%20quiet%20emotional%20urban%20mood%20high%20detail%20film%20still&width=1600&height=900&seq=mv-yr05b&orientation=landscape',
  },
  {
    id: '6',
    title: '深海回响',
    type: '电影',
    year: 2024,
    region: '中国大陆',
    duration: '131分钟',
    actors: ['程屿', '白露', '沈川'],
    director: '海问',
    genres: ['科幻', '悬疑', '冒险'],
    rating: 8.4,
    heat: 930000,
    description:
      '深海科考站在马里亚纳海沟底部接收到一段无法解释的低频信号。海洋地质学家白露带领团队下潜调查，却发现信号背后隐藏着一种从未被记录的智慧生命。深海之下的每一道回响，都在改写人类对世界的认知。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20poster%20of%20a%20deep%20sea%20submarine%20descending%20into%20dark%20abyss%20lit%20by%20warm%20orange%20beams%20deep%20blue%20ocean%20gradient%20tense%20mysterious%20atmosphere%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr06&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20deep%20ocean%20scene%20with%20a%20submersible%20glowing%20in%20dark%20water%20deep%20blue%20gradient%20with%20warm%20orange%20lamp%20beams%20mysterious%20underwater%20atmosphere%20high%20detail%20film%20still&width=1600&height=900&seq=mv-yr06b&orientation=landscape',
  },
  {
    id: '7',
    title: '甜心奇缘',
    type: '电视剧',
    year: 2025,
    region: '韩国',
    duration: '每集60分钟',
    episodes: 16,
    actors: ['车宥真', '李宰旭', '郑敏书'],
    director: '金成浩',
    genres: ['爱情', '喜剧', '都市'],
    rating: 7.9,
    heat: 780000,
    description:
      '天才甜品师车宥真因一场意外失去了味觉，为保住祖父留下的老店，她不得不与毒舌美食评论家李宰旭签订一份为期三个月的合作协议。从针锋相对到心意相通，甜与苦在同一个厨房里慢慢炖出了答案。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20romantic%20comedy%20poster%20of%20a%20smiling%20woman%20pastry%20chef%20in%20a%20cozy%20warm%20bakery%20with%20soft%20orange%20light%20deep%20blue%20accents%20playful%20sweet%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr07&orientation=portrait',
  },
  {
    id: '8',
    title: '铁血荣光',
    type: '电影',
    year: 2024,
    region: '中国大陆',
    duration: '146分钟',
    actors: ['霍东来', '秦锐', '孙岳'],
    director: '关山越',
    genres: ['动作', '战争', '剧情'],
    rating: 8.2,
    heat: 1050000,
    description:
      '抗美援朝战场上，一支被遗忘的侦察小队奉命穿越敌后执行一项几乎不可能完成的任务。在零下四十度的长津湖畔，他们用血肉之躯为战友争取到了宝贵的时间。枪林弹雨里，每一面旗帜都写着同一个名字：祖国。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20war%20film%20poster%20of%20soldiers%20silhouettes%20marching%20through%20snow%20at%20dawn%20deep%20blue%20cold%20tones%20with%20warm%20orange%20firelight%20epic%20heroic%20composition%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr08&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20soldiers%20crossing%20a%20snowy%20battlefield%20at%20dawn%20deep%20blue%20cold%20tones%20with%20warm%20orange%20explosion%20glow%20epic%20war%20film%20atmosphere%20high%20detail%20film%20still&width=1600&height=900&seq=mv-yr08b&orientation=landscape',
  },
  {
    id: '9',
    title: '迷雾列车',
    type: '电影',
    year: 2025,
    region: '日本',
    duration: '118分钟',
    actors: ['高桥凉介', '森川美咲', '中村彻'],
    director: '佐藤弦',
    genres: ['悬疑', '惊悚'],
    rating: 8.0,
    heat: 720000,
    description:
      '深夜末班列车驶入一条地图上不存在的隧道，乘客们发现列车再也无法停下。每到一个新站点，就有一名乘客被带走。为了活下去，素不相识的七个人必须在迷雾中找出隐藏在彼此之间的秘密。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20mystery%20poster%20of%20an%20old%20train%20emerging%20from%20thick%20fog%20at%20night%20deep%20blue%20tones%20with%20warm%20orange%20headlight%20glow%20eerie%20suspenseful%20atmosphere%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr09&orientation=portrait',
  },
  {
    id: '10',
    title: '青春正好',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    duration: '每集40分钟',
    episodes: 24,
    actors: ['夏知遥', '陆时安', '苏晓棠'],
    director: '叶南',
    genres: ['青春', '爱情', '校园'],
    rating: 7.8,
    heat: 690000,
    description:
      '高三那年，转学生夏知遥误打误撞加入了濒临解散的校园广播站，与冷面学霸陆时安成为搭档。在无数个排练到深夜的日子里，他们一起把看似枯燥的青春，过成了多年后仍会怀念的模样。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20youth%20drama%20poster%20of%20two%20students%20on%20a%20school%20rooftop%20at%20golden%20hour%20warm%20orange%20sunlight%20with%20deep%20blue%20shadows%20nostalgic%20fresh%20romantic%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr10&orientation=portrait',
  },
  {
    id: '11',
    title: '山河故人',
    type: '电影',
    year: 2024,
    region: '中国大陆',
    duration: '128分钟',
    actors: ['赵沧海', '宋青禾', '冯启山'],
    director: '吴立川',
    genres: ['剧情', '历史'],
    rating: 8.6,
    heat: 810000,
    description:
      '一座即将因水库建设而沉入水底的小镇，三代人在最后的春天里各自道别。老船工赵沧海守着渡口不肯离开，孙女宋青禾带着相机回来记录故土，而远在城市的父亲冯启山终于踏上了归途。故土会消失，记忆不会。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20of%20an%20old%20ferryman%20on%20a%20river%20at%20sunset%20misty%20mountains%20deep%20blue%20dusk%20with%20warm%20orange%20sun%20reflection%20quiet%20emotional%20composition%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr11&orientation=portrait',
  },
  {
    id: '12',
    title: '猎罪图鉴',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '每集43分钟',
    episodes: 30,
    actors: ['画像师沈墨', '刑警队长陆锋', '法医乔安'],
    director: '秦望',
    genres: ['犯罪', '悬疑', '刑侦'],
    rating: 8.8,
    heat: 1380000,
    description:
      '天才模拟画像师沈墨仅凭目击者三言两语，就能还原出嫌疑人面容。他与刑警队长陆锋组成搭档，用画笔揭开一桩桩离奇案件的真相。每一张被画出的脸背后，都藏着一个等待被倾听的故事。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20poster%20of%20a%20sketch%20artist%20drawing%20a%20face%20under%20stark%20light%20deep%20blue%20shadows%20with%20warm%20orange%20desk%20lamp%20focused%20intense%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr12&orientation=portrait',
  },
  {
    id: '13',
    title: '时空旅人',
    type: '电影',
    year: 2025,
    region: '美国',
    duration: '142分钟',
    actors: ['Ethan Cole', 'Mara Voss', 'Noah Reed'],
    director: 'Daniel Kraft',
    genres: ['科幻', '爱情'],
    rating: 8.3,
    heat: 890000,
    description:
      '物理学家Ethan意外掌握了一种只能向前跳跃的时空装置，却因此永远无法回到相遇的那一天。为了再见爱人Mara一面，他用尽一生穿越无数条时间线。原来最远的距离，不是光年，而是无法回头的昨天。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20romance%20poster%20of%20a%20man%20reaching%20toward%20a%20glowing%20clock%20portal%20deep%20blue%20cosmic%20tones%20with%20warm%20orange%20light%20poetic%20emotional%20composition%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr13&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20scene%20of%20a%20glowing%20time%20portal%20in%20a%20dark%20cosmic%20void%20deep%20blue%20tones%20with%20warm%20orange%20energy%20swirls%20dreamlike%20sci%20fi%20atmosphere%20high%20detail%20film%20still&width=1600&height=900&seq=mv-yr13b&orientation=landscape',
  },
  {
    id: '14',
    title: '医者仁心',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    duration: '每集45分钟',
    episodes: 36,
    actors: ['白景行', '林知夏', '陈默'],
    director: '方启年',
    genres: ['剧情', '职业', '都市'],
    rating: 8.5,
    heat: 1010000,
    description:
      '急诊科主任白景行在高压的工作节奏中坚守着最后一道生命防线。面对医患矛盾、资源短缺与个人抉择，他与年轻医生林知夏共同经历了一次次与死神赛跑的夜晚。手术台前没有奇迹，只有被无数次训练过的双手。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20poster%20of%20a%20doctor%20in%20a%20dim%20hospital%20corridor%20deep%20blue%20tones%20with%20warm%20orange%20light%20serious%20hopeful%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr14&orientation=portrait',
  },
  {
    id: '15',
    title: '王牌特工队',
    type: '电影',
    year: 2025,
    region: '中国香港',
    duration: '118分钟',
    actors: ['雷震', 'Ken 张', '阿豪'],
    director: '庄文强',
    genres: ['动作', '喜剧', '犯罪'],
    rating: 7.7,
    heat: 750000,
    description:
      '一支临时拼凑的“废柴”特工小队阴差阳错卷入一宗跨国文物走私案。一个嘴碎的司机、一个怕高的爆破手、一个只会做菜的卧底，再加上一个记不住暗号的新人，却意外掀翻了一个庞大的犯罪网络。笑料之外，兄弟情义照样热血。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20action%20comedy%20poster%20of%20a%20group%20of%20mismatched%20agents%20striking%20a%20pose%20deep%20blue%20backdrop%20with%20warm%20orange%20accents%20playful%20energetic%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr15&orientation=portrait',
  },
  {
    id: '16',
    title: '花间令',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    duration: '每集44分钟',
    episodes: 34,
    actors: ['楚瑶', '慕容昭', '陆轻舟'],
    director: '温知远',
    genres: ['古装', '爱情', '悬疑'],
    rating: 8.0,
    heat: 960000,
    description:
      '江湖第一女捕快楚瑶奉命调查一桩豪门灭门案，线索却指向当朝最受宠的年轻侯爷慕容昭。两人一明一暗，在查案与试探中渐生情愫。花间一壶酒，令下无冤魂，真相与真心，她只能选一个。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20chinese%20costume%20mystery%20poster%20of%20a%20woman%20warrior%20in%20elegant%20hanfu%20holding%20a%20sword%20in%20a%20moonlit%20garden%20deep%20blue%20night%20with%20warm%20orange%20lanterns%20elegant%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr16&orientation=portrait',
  },
  {
    id: '17',
    title: '沉默证人',
    type: '电影',
    year: 2024,
    region: '英国',
    duration: '126分钟',
    actors: ['Oliver Grant', 'Grace Hale', 'Thomas Reed'],
    director: 'James Whitmore',
    genres: ['犯罪', '悬疑', '剧情'],
    rating: 8.1,
    heat: 640000,
    description:
      '一位失语症少女是某起谋杀案唯一的目击者，却无法开口作证。辩护律师Grace Hale接手此案后，在无声的证词与冰冷的证据之间慢慢拼出真相。有时候，最响亮的证词恰恰来自沉默。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20courtroom%20thriller%20poster%20of%20a%20silent%20girl%20in%20shadow%20beside%20a%20tall%20window%20deep%20blue%20tones%20with%20warm%20orange%20light%20restrained%20tense%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr17&orientation=portrait',
  },
  {
    id: '18',
    title: '天空之城',
    type: '电视剧',
    year: 2025,
    region: '日本',
    duration: '每集24分钟',
    episodes: 26,
    actors: ['穹', '铃音', '巴鲁'],
    director: '宫崎野',
    genres: ['奇幻', '冒险', '动画'],
    rating: 8.9,
    heat: 1180000,
    description:
      '少年巴鲁拾到一枚会发光的古老吊坠，从此与从天而降的少女铃音一同踏上寻找传说中漂浮之城的旅程。云海之上，藏着一段被遗忘的文明，也藏着两个少年关于勇气与守护的全部答案。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20animated%20fantasy%20poster%20of%20two%20children%20flying%20among%20clouds%20toward%20a%20floating%20island%20deep%20blue%20sky%20with%20warm%20orange%20sunlight%20whimsical%20adventure%20mood%20high%20detail&width=600&height=900&seq=mv-yr18&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20animated%20scene%20of%20a%20floating%20island%20city%20in%20endless%20clouds%20deep%20blue%20sky%20with%20warm%20orange%20sunset%20light%20whimsical%20fantasy%20adventure%20atmosphere%20high%20detail&width=1600&height=900&seq=mv-yr18b&orientation=landscape',
  },
  {
    id: '19',
    title: '平凡岁月',
    type: '电视剧',
    year: 2024,
    region: '中国大陆',
    duration: '每集45分钟',
    episodes: 42,
    actors: ['孙德海', '李秀兰', '孙小满'],
    director: '刘家成',
    genres: ['剧情', '家庭', '年代'],
    rating: 8.4,
    heat: 870000,
    description:
      '从粮票年代到高楼林立的今天，老裁缝孙德海一家三代人在时代的浪潮里聚散离合。日子过得平平淡淡，却也藏着一针一线的深情。这是一个普通中国家庭的四十年，也是无数人的四十年。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20poster%20of%20an%20old%20tailor%20in%20a%20warm%20nostalgic%20workshop%20deep%20blue%20tones%20with%20warm%20orange%20lamp%20light%20gentle%20timeless%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr19&orientation=portrait',
  },
  {
    id: '20',
    title: '极速追杀',
    type: '电影',
    year: 2025,
    region: '美国',
    duration: '112分钟',
    actors: ['Dean Rourke', 'Vera Lang', 'Miles Cole'],
    director: 'Victor Stone',
    genres: ['动作', '犯罪', '惊悚'],
    rating: 7.6,
    heat: 700000,
    description:
      '退役赛车手Dean Rourke为了替被杀害的弟弟讨回公道，重返他曾经逃离的飙车世界。从沙漠公路到霓虹都市，一场横跨三个州县的极速追捕就此展开。引擎的轰鸣，是他唯一的语言。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20action%20poster%20of%20a%20muscle%20car%20speeding%20down%20a%20neon%20night%20highway%20deep%20blue%20tones%20with%20warm%20orange%20light%20trails%20intense%20adrenaline%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr20&orientation=portrait',
  },
  {
    id: '21',
    title: '恋恋笔记本',
    type: '电影',
    year: 2024,
    region: '韩国',
    duration: '121分钟',
    actors: ['韩智恩', '尹瑞俊', '朴敏雅'],
    director: '郑秀贤',
    genres: ['爱情', '剧情'],
    rating: 8.2,
    heat: 660000,
    description:
      '在一家即将拆迁的老书店里，店主韩智恩发现了一本写满陌生留言的旧笔记。循着字迹里的线索，她找到了留言的主人尹瑞俊，也走进了他未曾说完的那段青春。有些告白迟到十年，却依然滚烫。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20romance%20poster%20of%20a%20woman%20reading%20an%20old%20notebook%20in%20a%20dim%20cozy%20bookstore%20deep%20blue%20tones%20with%20warm%20orange%20lamplight%20tender%20nostalgic%20mood%20high%20detail%20film%20poster&width=600&height=900&seq=mv-yr21&orientation=portrait',
  },
  {
    id: '22',
    title: '破晓行动',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '每集43分钟',
    episodes: 34,
    actors: ['顾寒声', '叶晚', '老周'],
    director: '沈墨白',
    genres: ['谍战', '悬疑', '年代'],
    rating: 8.7,
    heat: 1290000,
    description:
      '1944年的上海滩，代号“破晓”的地下党员顾寒声潜伏在敌人心脏已三年。一条失联的密电、一位突然出现的旧识，让他的身份濒临暴露。黎明之前最是黑暗，而他必须撑到最后一秒。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20spy%20thriller%20poster%20of%20a%20man%20in%20a%20long%20coat%20in%20a%20rainy%20old%20shanghai%20street%20deep%20blue%20tones%20with%20warm%20orange%20streetlight%20tense%20noir%20mood%20high%20detail%20film%20poster%20aesthetic&width=600&height=900&seq=mv-yr22&orientation=portrait',
  },
  {
    id: '23',
    title: '海洋奇缘',
    type: '电影',
    year: 2024,
    region: '美国',
    duration: '106分钟',
    actors: ['Malia', 'Kai', 'Rangi'],
    director: 'Ron Clemmons',
    genres: ['动画', '冒险', '家庭'],
    rating: 8.5,
    heat: 920000,
    description:
      '少女Malia出生在一个禁止出海的小岛，却对大海有着无法抑制的向往。当岛屿遭遇神秘诅咒，她偷偷驾船远航，与半神Kai一起穿越风暴与暗礁，去寻找传说中能平息大海怒火的之心。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20animated%20adventure%20poster%20of%20a%20young%20girl%20sailing%20a%20canoe%20across%20a%20vivid%20ocean%20deep%20blue%20waves%20with%20warm%20orange%20sunset%20joyful%20adventure%20mood%20high%20detail&width=600&height=900&seq=mv-yr23&orientation=portrait',
  },
  {
    id: '24',
    title: '都市浮生',
    type: '电视剧',
    year: 2025,
    region: '中国大陆',
    duration: '每集42分钟',
    episodes: 30,
    actors: ['程亦然', '唐果', '许愿'],
    director: '陆文',
    genres: ['都市', '剧情', '爱情'],
    rating: 8.0,
    heat: 930000,
    description:
      '广告公司创意总监程亦然在职场的巅峰遭遇中年危机，与刚入职的实习生唐果意外成为合租室友。两个年龄、观念都截然不同的人，在同一屋檐下重新理解了生活。都市浮生，不过是想在这座城市里找到属于自己的那盏灯。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%20of%20two%20people%20on%20a%20city%20balcony%20overlooking%20a%20night%20skyline%20deep%20blue%20tones%20with%20warm%20orange%20window%20lights%20reflective%20modern%20mood%20high%20detail&width=600&height=900&seq=mv-yr24&orientation=portrait',
  },
];

export const regionOptions = ['全部', '中国大陆', '中国香港', '美国', '韩国', '日本', '英国'];

export const yearOptions = ['全部', '2025', '2024', '2023'];

export const sortOptions = [
  { value: 'latest', label: '最新上线' },
  { value: 'heat', label: '热度最高' },
  { value: 'rating', label: '评分最高' },
];

export const typeOptions = ['全部', '电视剧', '电影'];